import React, { createContext, useState } from 'react';

const TimerContext = createContext({
    expTime: 0,
    expired: false,
    onUpdateTime: () => {},
    onUpdateExpried: () => {},
});

export const TimerContextProvider = ({ children }) => {
    const [expTime, setExpTime] = useState(0);
    const [expired, setExpired] = useState(false);

    const updateTimeHandler = (time) => {
        setExpTime(time);
    }
    const updateExpiredHandler = (bool) => {
        setExpired(bool);
    }
    return (
        <TimerContext.Provider
            value={{
                expTime: expTime,
                expired: expired,
                onUpdateTime: updateTimeHandler,
                onUpdateExpried: updateExpiredHandler,
            }}
        >
            {children}   
        </TimerContext.Provider>
    )
}

export default TimerContext;